import $ from 'jquery';
import { ajaxDelete } from '@/js/modules/ajax';
import { onPageLoad } from '@/js/modules/page_load';
import '@/js/modules/jquery_modal_defaults';

onPageLoad(() => {
  const sortPresets = ($options) => {
    const sortedList = $options.find('.load-preset__option').sort((leftOption, rightOption) => {
      return $(leftOption).find('.load-preset__load').text().toLowerCase() <
        $(rightOption).find('.load-preset__load').text().toLowerCase()
        ? -1
        : 1;
    });
    $options.empty();
    sortedList.each((_, option) => {
      $(option).appendTo($options);
    });
  };

  $(document).on('click', '.p-button--save-preset', (e) => {
    e.preventDefault();
    const $form = $(e.target).closest('form');
    if ($form.find('.field--preset-title').val().trim().length === 0) {
      $form.find('.error-message').show();
      $form.find('.field--preset-title').focus();
      return false;
    } else {
      $form.find('.error-message').hide();

      const $submit = $form.find('input[type=submit]');
      $submit.addClass('button-loading').prop('disabled', true);
      const method = $form.find('input[name="_method"]').val() || 'post';

      $.ajax({ url: $form.attr('action'), type: method, data: $form.serialize() }).done(
        (presetOptionHtml) => {
          const $option = $(presetOptionHtml);
          const id = $option.attr('data-id');
          const isSendBillables = $option.attr('data-send-billables') === 'true';
          let $container;
          if (isSendBillables) {
            $container = $('.send-billable-form').find('.load-preset__options');
          }

          if ($container) {
            const $existingOption = $container.find(`.load-preset__option[data-id=${id}]`);
            if ($existingOption.length > 0) {
              $existingOption.replaceWith(presetOptionHtml);
            } else {
              $option.appendTo($container);
            }

            sortPresets($container);
            $container.siblings('.load-preset__link').removeClass('load-preset__link--disabled');
            $container.closest('.load-preset').removeClass('load-preset--active');
          }
          $(e.target).closest('.modal--preset-form').find('.close-modal').click();
        }
      );
    }
  });

  $(document).on('click', '.load-preset__link', (e) => {
    $(e.target).closest('.load-preset').toggleClass('load-preset--active');
  });
  $(document).on('click', '.load-preset__load', (e) => {
    e.preventDefault();
    $.get(e.target.href).done((preset) => {
      if ($(e.target).closest('.send-billable-form__message-body').length > 0) {
        $(e.target)
          .closest('.send-billable-form__message-body')
          .siblings('.field--send-billable-message')
          .val(preset.details);
      } else if ($('.field--invoice-payment-form-custom-message').length > 0) {
        $('.field--invoice-payment-form-custom-message').val(preset.details);
      }

      // trigger preset loaded event so can be listened elsewhere
      $(document).trigger('preset:load', preset.details);
      $(e.target).closest('.load-preset').toggleClass('load-preset--active');
    });
  });

  $(document).on('click', '.load-preset__delete', (e) => {
    e.preventDefault();
    if (confirm('Are you sure?')) {
      const $container = $(e.target).closest('.load-preset__option');
      $container.addClass('load-preset__option--disabled');
      ajaxDelete(e.target.href, {}, () => {
        const $presets = $(e.target).closest('.load-preset__options');

        $container.remove();
        if ($presets.find('.load-preset__option').length === 0) {
          $presets
            .closest('.load-preset')
            .removeClass('load-preset--active')
            .find('.load-preset__link')
            .addClass('load-preset__link--disabled');
        }
      });
    }
    return false;
  });

  $(document).on(
    'click',
    '#quotes-edit, #invoices-edit, #contracts-edit, #purchase-orders-edit, #board, #boards, #fp-boards-floorplan',
    (e) => {
      const $preset = $(e.target).closest('.load-preset');
      if (!$preset.length) {
        $('.load-preset').each((_, el) => {
          if ($(el).hasClass('load-preset--active')) {
            $(el).removeClass('load-preset--active');
          }
        });
      }
    }
  );

  $(document).on($.modal.BEFORE_OPEN, '.modal--preset-form', (e) => {
    const isSendBillables = $(e.target).attr('data-send-billables') === 'true';

    if ($('.send-billable-form__message-body').length > 0 && isSendBillables) {
      $('.preset-details').val(
        $('.send-billable-form__message-body').siblings('.field--send-billable-message').val()
      );
    } else if ($('.field--invoice-payment-form-custom-message').length > 0) {
      $('.preset-details').val($('.field--invoice-payment-form-custom-message').val());
    }
  });

  $(document).on($.modal.AFTER_CLOSE, '.modal--preset-form', (e) => {
    $(e.target).remove();
  });

  $(document).on('click', '.t-button--preset-cancel-link', (e) => {
    e.preventDefault();
    $('.close-modal').click();
  });

  $(document).on('keyup paste change', '.field--preset-title', (e) => {
    const $form = $(e.target).closest('form');
    if ($(e.target).val().trim().length === 0) {
      $form.find('.error-message').show();
    } else {
      $form.find('.error-message').hide();
    }
  });

  $(document).on('click', '.load-preset__edit, [data-command="preset:edit"]', (e) => {
    e.preventDefault();
    const presetEditPath = e.target.href || e.currentTarget.value;
    $.get(presetEditPath, (modalPresetForm) => {
      $(modalPresetForm).appendTo('body').modal();
    });
  });
});
